import { ISelectOptionProps } from 'components/form/types';
import { TFunction } from 'i18next';
import { IFilterOptions } from '../types';

export const filters = {
  status: {
    name: 'is_active' as keyof IFilterOptions,
    placeholder: 'table.statusFilter',
    options: [
      {
        label: 'table.activeStatus',
        value: 'true',
      },
      {
        label: 'table.inactiveStatus',
        value: 'false',
      },
    ],
    translatable: true,
  },
  fieldType: {
    name: 'type' as keyof IFilterOptions,
    placeholder: 'table.typeFilter',
    options: [
      {
        value: 'text',
        label: 'Text',
      },
      {
        value: 'textarea',
        label: 'Text Area',
      },
      {
        value: 'dropdown',
        label: 'Drop Down',
      },
      {
        value: 'datepicker',
        label: 'Date Picker',
      },
      {
        value: 'icon',
        label: 'Icon',
      },
      {
        value: 'numeric-integer',
        label: 'Number',
      },
    ],
    translatable: true,
  },
};

export const buildFilters = ({
  name,
  placeholder,
  ariaLabel,
  options,
  t,
  translatable,
  isMulti,
  showTotal,
  type,
  subType,
  hidden,
  limitOptions,
  allowSelectAll,
  icon,
  setLastMonth,
  size,
}: {
  name: string;
  placeholder?: string;
  ariaLabel?: string;
  options?: ISelectOptionProps[];
  t?: TFunction;
  translatable?: boolean;
  isMulti?: boolean;
  showTotal?: boolean;
  subType?: string;
  hidden?: boolean;
  limitOptions?: boolean;
  icon?: any;
  allowSelectAll?: boolean;
  type?: 'datepicker' | 'alldatepicker' | 'monthyearpicker' | 'monthyearpickerend' | 'monthyearpickerstart' | 'icon';
  setLastMonth?: boolean;
  size?: 'small' | 'medium' | 'large';
}) => {
  return {
    name: name as keyof IFilterOptions,
    placeholder: translatable ? t && placeholder && (t(placeholder) || placeholder) : placeholder,
    ariaLabel,
    options: translatable
      ? t &&
        options?.map(opt => ({
          ...opt,
          label: t(opt.label) || opt.label,
        }))
      : options,
    isMulti,
    showTotal,
    subType,
    icon,
    limitOptions,
    type,
    hidden,
    allowSelectAll,
    setLastMonth,
    size,
  };
};
